export default __webpack_public_path__ + "static/media/d2.3d005a55.png";